<template>
  <div>
    <Worktemp
      data-aos="fade-down"
      :workTitle="work.tittle"
      :workPara="work.para"
      :companyName="work.company"
      :yearName="work.year"
      :projectType="work.project"
    ></Worktemp>
    <WorkcoverImg :coverimg="work.coverimg" data-aos="fade-up" />
    <WorkTwoImg :TwoImgleft="work.TwoImgleft" :TwoImgRight="work.TwoImgRight" />
    <WorkThreeImg
      :ThreeImgleft="work.ThreeImgleft"
      :ThreeImgRight="work.ThreeImgRight"
    />
    <WorkcoverImg :coverimg="work.coverimg2" />
    <hire />
  </div>
</template>
<script>
import Worktemp from "@/components/Worktemp.vue";
import WorkcoverImg from "@/components/WorkcoverImg.vue";
import WorkTwoImg from "@/components/WorkTwoImg.vue";
import WorkThreeImg from "@/components/WorkThreeImg.vue";
export default {
  components: {
    Worktemp,
    WorkcoverImg,
    WorkTwoImg,
    WorkThreeImg,
  },
  data() {
    return {
      work: {
        tittle: "Zsites",
        para: "Zsites is an in-house project of Cobold Digital. With zsites, one can get a website delivered in just 7 days. I did the UI design for the website. The design was precisely done to build a position that users can trust us while scrolling through the website. Kept the user journey so smooth while highlighting all key features & CTA's. Appreciate the hard work put in by the content, development & management team involved in this project. ",
        company: "GLB International Services",
        year: "2021",
        project: "UI/UX",
        coverimg: "/img/gallery/ui/zsites/cover.jpg",
        TwoImgleft: "/img/gallery/ui/zsites/twoleft.svg",
        TwoImgRight: "/img/gallery/ui/zsites/tworight.svg",
        ThreeImgleft: "/img/gallery/ui/zsites/threeleft.svg",
        ThreeImgRight: "/img/gallery/ui/zsites/threeright.svg",
        coverimg2: "/img/gallery/ui/zsites/cover2.jpg",
      },
    };
  },
};
</script>
